import React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import NumericInput from 'react-numeric-input';
import abcjs from "@bittnerdevelopmentgroup/abcjs";
import DestructiveButton from '../controls/DestructiveButton';
import { useForceUpdate } from '../util';
import { FormValidityProvider, FormValidityReporter } from '../FormValidity';
import { TabContextReporter } from '../TabContext';
export function findClefIndex(fullString) {
  let trebleIndex = fullString.indexOf(" treble");
  let bassIndex = fullString.indexOf(" bass");
  let altoIndex = fullString.indexOf(" alto");
  if (trebleIndex !== -1) {
    return trebleIndex;
  } else if (bassIndex !== -1) {
    return bassIndex;
  } else {
    return altoIndex;
  }
}
export function setClef(fullString, newClef) {
  fullString = fullString.replace(fullString.slice(findClefIndex(fullString), fullString.length), "");
  return fullString + ' ' + newClef;
}
export function getClef(fullString) {
  let clef = fullString.slice(findClefIndex(fullString) + 1, fullString.length);
  return clef.charAt(0).toUpperCase() + clef.slice(1);
}
export function getMusicPropertyIndices(fullString, property) {
  let start = fullString.indexOf(property);
  let end = fullString.slice(start).indexOf(";");
  if (end === -1) {
    // if its at the end of the config options
    end = fullString.slice(start).indexOf(" ") + start;
  } else {
    end += start;
  }
  return {
    start,
    end
  };
}
export function getTimeSignature(fullString) {
  let {
    start,
    end
  } = getMusicPropertyIndices(fullString, 'M:');
  if (end - start < 0) {
    // property doesn't exist
    return '';
  }
  let timeSignature = fullString.slice(start + 2, end);
  if (timeSignature === "C") {
    return "Common Time";
  } else if (timeSignature === "C|") {
    return "Cut Time";
  } else {
    return timeSignature;
  }
}
export function setMusicProperty(fullString, property, value) {
  let {
    start,
    end
  } = getMusicPropertyIndices(fullString, property);
  if (end - start < 0) {
    // property doesn't exist
    let separator = fullString.indexOf(" ");
    let newString = fullString.slice(0, separator) + ";" + property + value + fullString.slice(separator);
    return newString;
  }
  let newString = fullString.slice(0, start) + property + value + fullString.slice(end);
  return newString;
}
export function getMusicPropertyValue(fullString, property) {
  let {
    start,
    end
  } = getMusicPropertyIndices(fullString, property);
  if (end - start < 0) {
    // property doesn't exist
    return '';
  }
  return fullString.slice(start + 2, end);
}

/*
const keysigs = [
  'C#', 'C#maj', 'A#m', 'G#Mix', 'D#Dor', 'E#Phr', 'F#Lyd', 'B#Loc',
  'F#', 'F#maj', 'D#m', 'C#Mix', 'G#Dor', 'A#Phr', 'BLyd', 'E#Loc',
  'B', 'Bmaj', 'G#m', 'F#Mix', 'C#Dor', 'D#Phr', 'ELyd', 'A#Loc',
  'E', 'Emaj', 'C#m', 'BMix', 'F#Dor', 'G#Phr', 'ALyd', 'D#Loc',
  'A', 'Amaj', 'F#m', 'EMix', 'BDor', 'C#Phr', 'DLyd', 'G#Loc',
  'D', 'Dmaj', 'Bm', 'AMix', 'EDor', 'F#Phr', 'GLyd', 'C#Loc',
  'G', 'Gmaj', 'Em', 'DMix', 'ADor', 'BPhr', 'CLyd', 'F#Loc',
  'C', 'Cmaj', 'Am', 'GMix', 'DDor', 'EPhr', 'FLyd', 'BLoc',
  'F', 'Fmaj', 'Dm', 'CMix', 'GDor', 'APhr', 'BbLyd', 'ELoc',
  'Bb', 'Bbmaj', 'Gm', 'FMix', 'CDor', 'DPhr', 'EbLyd', 'ALoc',
  'Eb', 'Ebmaj', 'Cm', 'BbMix', 'FDor', 'GPhr', 'AbLyd', 'DLoc',
  'Ab', 'Abmaj', 'Fm', 'EbMix', 'BbDor', 'CPhr', 'DbLyd', 'GLoc',
  'Db', 'Dbmaj', 'Bbm', 'AbMix', 'EbDor', 'FPhr', 'GbLyd', 'CLoc',
  'Gb', 'Gbmaj', 'Ebm', 'DbMix', 'AbDor', 'BbPhr', 'CbLyd', 'FLoc',
  'Cb', 'Cbmaj', 'Abm', 'GbMix', 'DbDor', 'EbPhr', 'FbLyd', 'BbLoc',
  'none', 'HP', 'Hp'
]
*/

const keys = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
const accidentals = ['', 'b', '#'];
const scales = ['', 'maj', 'm', 'min', 'Mix', 'Dor', 'Phr', 'Lyd', 'Loc'];
const extras = ['none', 'HP', 'Hp'];
const invalids = ["B#m", "B#min", "E#m", "E#min"];
/*const keysigs = keys.map(key => 
  accidentals.map(accidental => 
    scales.map(scale => 
      key + accidental + scale
    ).flat()
  ).flat()
).flat()
.concat(extras)
.filter(key => !invalids.includes(key))

function isValidKeySignatureLookup(key) {
  let firstSpace = key.indexOf(' ')
  if (firstSpace !== -1) {
    return keysigs.includes(key.substring(0, firstSpace))
  }
  return keysigs.includes(key)
}*/

function isValidKeySignatureIterative(key) {
  //console.log("isValidKeySignature", key)
  for (const e of extras) {
    if (key.startsWith(e)) {
      return true;
    }
  }
  for (const k of keys) {
    if (key.startsWith(k)) {
      for (const a of accidentals) {
        if (key.startsWith(a, k.length)) {
          for (const s of scales) {
            if (key.startsWith(s, k.length + a.length)) {
              if (invalids.includes(k + a + s)) {
                return false;
              }
              if ([' ', undefined].includes(key[k.length + a.length + s.length])) {
                return true;
              }
            }
          }
        }
      }
    }
  }
  return false;
}
export function isValidKeySignature(key) {
  return isValidKeySignatureIterative(key); // This one's faster
  /*
  performance.mark("isValidKeySignature a")
  for (let i = 0; i < 10000; ++i) {
    var a = isValidKeySignatureIterative(key)
  }
  performance.mark("isValidKeySignature ab")
  for (let i = 0; i < 10000; ++i) {
    var b = isValidKeySignatureLookup(key)
  }
  performance.mark("isValidKeySignature b")
  if (a !== b) {
    throw new Error("isValidKeySignature returned different results!")
  }
  performance.measure("isValidKeySignature measure a", "isValidKeySignature a", "isValidKeySignature ab")
  performance.measure("isValidKeySignature measure b", "isValidKeySignature ab", "isValidKeySignature b")
  performance.clearMarks()
  performance.clearMeasures()
  return a
  */
}

export function isValidNotation(notation) {
  var _parse$, _parse$$lines;
  let parse = abcjs.parseOnly(notation, {
    generate_warnings: true
  });
  return ((_parse$ = parse[0]) === null || _parse$ === void 0 ? void 0 : (_parse$$lines = _parse$.lines) === null || _parse$$lines === void 0 ? void 0 : _parse$$lines.length) > 0;
}
export default function TaskChordBuilder(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  const [customTime, setCustomTime] = React.useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "1. Initial Information"
  }, /*#__PURE__*/React.createElement(FormValidityProvider, {
    onChange: props.onValidityChange
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Clef:")), /*#__PURE__*/React.createElement(Dropdown, {
    className: "mx-2"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basic"
  }, getClef(dataProps.musicConfiguration)), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setClef(dataProps.musicConfiguration, "treble");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "Treble"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setClef(dataProps.musicConfiguration, "bass");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "Bass"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setClef(dataProps.musicConfiguration, "alto");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "Alto")))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Time Signature:")), /*#__PURE__*/React.createElement(Dropdown, {
    className: "mx-2"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basic"
  }, getTimeSignature(dataProps.musicConfiguration)), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(false);
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'M:', "C");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "Common Time"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(false);
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'M:', "C|");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "Cut Time"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(false);
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'M:', "3/4");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "3/4"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(false);
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'M:', "4/4");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "4/4"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(false);
      let {
        start,
        end
      } = getMusicPropertyIndices(dataProps.musicConfiguration, 'M:');
      if (end - start < 0) {
        // property doesn't exist
        return '';
      }
      let mOffset = 2;
      dataProps.musicConfiguration = dataProps.musicConfiguration.replace(dataProps.musicConfiguration.slice(start + mOffset, end + 1), ';');
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "Clear"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(true);
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "Custom"))), customTime && /*#__PURE__*/React.createElement(Col, {
    style: {
      margin: "1rem 0rem"
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: getTimeSignature(dataProps.musicConfiguration),
    onChange: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'M:', e.target.value);
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 6
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Base Note Length:"), " ", /*#__PURE__*/React.createElement("i", null, "The base note value for abc.")), /*#__PURE__*/React.createElement(Dropdown, {
    className: "mx-2"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basic"
  }, getMusicPropertyValue(dataProps.musicConfiguration, 'L:')), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/1");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "1/1"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/2");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "1/2"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/4");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "1/4"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/8");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "1/8"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/16");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "1/16"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/32");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "1/32"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/64");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "1/64"))))), /*#__PURE__*/React.createElement(Col, {
    xs: 3
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Key:")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: getMusicPropertyValue(dataProps.musicConfiguration, 'K:'),
    onChange: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'K:', e.target.value);
      //props.triggerStateUpdate()
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: isValidKeySignature(getMusicPropertyValue(dataProps.musicConfiguration, 'K:'))
  }, "Please type in a valid key signature.")))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Measure Time:"), " ", /*#__PURE__*/React.createElement("i", null, "The time it takes to play a measure in miliseconds.")), /*#__PURE__*/React.createElement(NumericInput, {
    min: 0,
    value: parseInt(dataProps.musicDuration),
    onChange: e => {
      if (e) {
        dataProps.musicDuration = e.toString();
        forceUpdate();
        props.onChanged();
      } else {
        dataProps.musicDuration = "0";
        forceUpdate();
        props.onChanged();
      }
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Minimum Height:"), " ", /*#__PURE__*/React.createElement("i", null, "The minimum height of the sheet. Adjust to fit.")), /*#__PURE__*/React.createElement(NumericInput, {
    min: 0,
    value: parseInt(dataProps.minHeight) || 320,
    onChange: e => {
      if (e) {
        dataProps.minHeight = e.toString() + "px";
        props.triggerStateUpdate();
      } else {
        dataProps.minHeight = "0";
        props.triggerStateUpdate();
      }
    }
  })), /*#__PURE__*/React.createElement(Form.Group, {
    style: {
      paddingBottom: '1em'
    }
  }, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Range:"), " ", /*#__PURE__*/React.createElement("i", null, "The range (?)")), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: '.5em'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      float: 'left'
    }
  }, "Lower:"), /*#__PURE__*/React.createElement("span", {
    style: {
      float: 'right'
    }
  }, /*#__PURE__*/React.createElement(NumericInput, {
    max: dataProps.rangeUpper,
    value: dataProps.rangeLower = dataProps.rangeLower ? dataProps.rangeLower : -3,
    onChange: e => {
      if (e > dataProps.rangeUpper) dataProps.rangeLower = dataProps.rangeUpper;else dataProps.rangeLower = e;
      props.triggerStateUpdate();
    }
  }))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: '.5em'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      float: 'left'
    }
  }, "Upper:"), /*#__PURE__*/React.createElement("span", {
    style: {
      float: 'right'
    }
  }, /*#__PURE__*/React.createElement(NumericInput, {
    min: dataProps.rangeLower,
    value: dataProps.rangeUpper = dataProps.rangeUpper ? dataProps.rangeUpper : 15,
    onChange: e => {
      if (e < dataProps.rangeLower) dataProps.rangeUpper = dataProps.rangeLower;else dataProps.rangeUpper = e;
      props.triggerStateUpdate();
    }
  }))), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: dataProps.rangeLower <= dataProps.rangeUpper
  }, /*#__PURE__*/React.createElement("br", null), "Ensure the Lower bound is less than the Greater bound.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Initial Score:"), " ", /*#__PURE__*/React.createElement("i", null, "The initial notes to be displayed (abc notation)")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.musicInitial,
    onChange: e => {
      dataProps.musicInitial = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: isValidNotation(dataProps.musicConfiguration.split(';').join('\n') + '\n' + dataProps.musicInitial)
  }, "Invalid")))), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "1",
    title: "2. Response Details"
  }, /*#__PURE__*/React.createElement(FormValidityProvider, {
    onChange: props.onValidityChange
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Answer(s):"), " ", /*#__PURE__*/React.createElement("i", null, "(abc notation)")), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, "Answer:")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, "Feedback:")), /*#__PURE__*/React.createElement(Col, {
    xs: 1,
    style: {
      marginRight: "1rem"
    }
  }, /*#__PURE__*/React.createElement(Form.Label, null, "Correct:")), /*#__PURE__*/React.createElement(Col, {
    xs: 1,
    style: {
      marginRight: "1rem"
    }
  })), dataProps.answers.map((v, k) => {
    return /*#__PURE__*/React.createElement(Row, {
      style: {
        marginBottom: ".5rem"
      }
    }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
      key: k + "1",
      as: "textarea",
      value: v.answer,
      onChange: e => {
        dataProps.answers[k].answer = e.target.value;
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(FormValidityReporter, {
      valid: dataProps.answers[k].answer.length > 0
    }, "Please type in some notation.")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
      key: k + "2",
      as: "textarea",
      value: v.feedback,
      onChange: e => {
        dataProps.answers[k].feedback = e.target.value;
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(FormValidityReporter, {
      valid: dataProps.answers[k].feedback.length > 0
    }, "Please type in some feedback.")), /*#__PURE__*/React.createElement(Col, {
      xs: 1
    }, /*#__PURE__*/React.createElement(Form.Check, {
      key: k,
      type: "checkbox",
      checked: v.correct,
      onChange: e => {
        dataProps.answers[k].correct = e.target.checked;
        forceUpdate();
        props.onChanged();
      }
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 1,
      style: {
        marginRight: ".5rem"
      }
    }, /*#__PURE__*/React.createElement(DestructiveButton, {
      size: "sm",
      variant: "danger",
      title: "Remove answer",
      text: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-trash"
      }),
      confirmation: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-question-lg"
      }),
      className: "fs-sm",
      onClick: () => {
        dataProps.answers.splice(k, 1);
        forceUpdate();
        props.onChanged();
      }
    })));
  }), /*#__PURE__*/React.createElement(Button, {
    title: "Add an answer",
    variant: "success",
    style: {
      margin: '.5rem .25rem'
    },
    onClick: () => {
      dataProps.answers.push({
        answer: "[]",
        feedback: "placeholder",
        correct: true
      });
      forceUpdate();
      props.onChanged();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi bi-plus-lg"
  }))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "General Incorrect Feedback:"), " ", /*#__PURE__*/React.createElement("i", null, "The feedback the user will see if they get the question incorrect.")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.feedbackIncorrect,
    onChange: e => {
      dataProps.feedbackIncorrect = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  }))))), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "2",
    title: "3. Accidental Buttons"
  }, /*#__PURE__*/React.createElement(FormValidityProvider, {
    onChange: props.onValidityChange
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    checked: dataProps.musicButtonAudio,
    onChange: e => {
      dataProps.musicButtonAudio = e.target.checked;
      props.triggerStateUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Play Button:"), " ", /*#__PURE__*/React.createElement("i", null, "If checked, the play button will be displayed."))))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    checked: dataProps.musicButtonFlat,
    onChange: e => {
      dataProps.musicButtonFlat = e.target.checked;
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Flat Button:"), " ", /*#__PURE__*/React.createElement("i", null, "If checked, the flat button will be displayed."))))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    checked: dataProps.musicButtonSharp,
    onChange: e => {
      dataProps.musicButtonSharp = e.target.checked;
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Sharp Button:"), " ", /*#__PURE__*/React.createElement("i", null, "If checked, the sharp button will be displayed."))))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    checked: dataProps.musicButtonNatural,
    onChange: e => {
      dataProps.musicButtonNatural = e.target.checked;
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Natural Button:"), " ", /*#__PURE__*/React.createElement("i", null, "If checked, the natural button will be displayed."))))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    checked: dataProps.musicButtonDoubleFlat,
    onChange: e => {
      dataProps.musicButtonDoubleFlat = e.target.checked;
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Double Flat Button:"), " ", /*#__PURE__*/React.createElement("i", null, "If checked, the double flat button will be displayed."))))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    checked: dataProps.musicButtonDoubleSharp,
    onChange: e => {
      dataProps.musicButtonDoubleSharp = e.target.checked;
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Double Sharp Button:"), " ", /*#__PURE__*/React.createElement("i", null, "If checked, the double sharp button will be displayed.")))))))));
}